var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "service-banner area"
  }, [_c("div", [_c("span", {
    staticClass: "puhui-M"
  }, [_vm._v(_vm._s(_vm.title))])]), _c("div", {
    staticClass: "description"
  }, [_c("span", {
    style: _vm.descriptionStyle
  }, [_vm._v(_vm._s(_vm.description))])]), _vm.showAppoint ? _c("div", {
    staticClass: "btn"
  }, [_c("button", {
    staticClass: "custom-btn more-btn",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleAppoint
    }
  }, [_vm._v(" 立即预约 ")])]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };